import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Inject,
  Page,
  Search,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import React from "react";
import { FaRegEye } from "react-icons/fa";
import { HiOutlinePencilSquare } from "react-icons/hi2";

const DataTable = ({ data, grid, handleShowModal }) => {
  // console.log("data", data);
  const actionTemplate = (item) => (
    <div className="flex justify-center items-center space-x-4">
      {/* <button
        onClick={() => handleShowModal(item)}
        className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
        <FaRegEye />
      </button> */}
      <button
        onClick={() => handleShowModal(item)}
        className="w-7 h-7 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
        <HiOutlinePencilSquare />
      </button>
    </div>
  );

  return (
    <GridComponent
      dataSource={data}
      
      allowSorting
      toolbar={["Search"]}
      width="auto">
      <ColumnsDirective>
        {grid?.map((item, index) => (
          <ColumnDirective key={index} {...item} className="font-semibold" />
        ))}
        <ColumnDirective
          headerText="Action"
          width="30"
          field="action"
          template={actionTemplate}
        />
      </ColumnsDirective>
      <Inject services={[Page, Edit, Toolbar, Search]} />
    </GridComponent>
  );
};

export default DataTable;
